import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../../services/contexts/AuthContext';
import TenantDoctorSidebar from './components/TenantDoctorSidebar';
import TenantDoctorDashboard from './pages/TenantDoctorDashboard';
import PatientReview from './pages/PatientReview';
import ClinicalAnalytics from './pages/ClinicalAnalytics';
import { LogOut } from 'lucide-react';

const TenantDoctorApp = () => {
  const { user, logout } = useAuth();
  const [activeView, setActiveView] = useState('dashboard');

  const handleLogout = () => {
    logout();
  };

  return (
    <div className="flex h-screen bg-gray-50">
      {/* Tenant Doctor Sidebar */}
      <TenantDoctorSidebar activeView={activeView} setActiveView={setActiveView} />
      
      {/* Main Content Area */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Top Navigation Bar */}
        <header className="bg-white shadow-sm border-b border-gray-200">
          <div className="flex items-center justify-between px-6 py-4">
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Clinical Review Portal</h1>
              {/* <p className="text-sm text-gray-600">Clinical decision support and patient assessment</p> */}
            </div>
            <div className="flex items-center space-x-4">
              {/* <div className="text-right">
                <p className="text-sm font-medium text-gray-900">{user?.name}</p>
                <p className="text-xs text-gray-500">Clinical Physician</p>
              </div> */}
              <button
                onClick={handleLogout}
                className="flex items-center space-x-2 px-4 py-2 text-sm text-gray-700 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors"
              >
                <LogOut className="h-4 w-4" />
                <span>Logout</span>
              </button>
            </div>
          </div>
        </header>

        {/* Content Area */}
        <main className="flex-1 overflow-auto p-6">
          <Routes>
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<TenantDoctorDashboard />} />
            <Route path="patients" element={<PatientReview />} />
            <Route path="vitals" element={
              <div className="text-center py-12">
                <h2 className="text-xl font-bold text-gray-900 mb-4">Vitals Analysis</h2>
                <p className="text-gray-600">Advanced vital signs analysis coming soon...</p>
              </div>
            } />
            <Route path="clinical-notes" element={
              <div className="text-center py-12">
                <h2 className="text-xl font-bold text-gray-900 mb-4">Clinical Notes</h2>
                <p className="text-gray-600">Clinical documentation system coming soon...</p>
              </div>
            } />
            <Route path="diagnostics" element={
              <div className="text-center py-12">
                <h2 className="text-xl font-bold text-gray-900 mb-4">Diagnostic Review</h2>
                <p className="text-gray-600">AI-powered diagnostic assistance coming soon...</p>
              </div>
            } />
            <Route path="analytics" element={<ClinicalAnalytics />} />
          </Routes>
        </main>
      </div>
    </div>
  );
};

export default TenantDoctorApp;